import * as Effects from 'redux-saga/effects'
import { put } from 'redux-saga/effects'
import { callFetch } from '../../actions/fetch'
import { IRequestPaymentDictionaries } from '../../actions/paymentDictionary/loadDictionaries'
import { ITaxesDictionary } from '../../models/PaymentDictionary'
import { PaymentDictionaryActions } from '../../reducers/paymentDictionary/actionNames'
import fetchActionsName from '../../utils/FetchActionsName/fetchActionsName'
import { ActionNames } from '../../utils/FetchActionsName'
import fetchTaxes from '../../models/PaymentDictionary/fetchTaxes'
import updateTaxes from '../../models/PaymentDictionary/updateTaxes'
import { fireToastSuccess } from '../../actions/toasts/fireToast'
import i18n from '../../i18n'
import { change } from 'redux-form'

function* loadTaxes(action: IRequestPaymentDictionaries) {
  try {
    const actionNames = fetchActionsName(ActionNames.FetchTaxes)
    const [{ service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(callFetch(actionNames.input, actionNames.output, fetchTaxes)),
    ])

    const dictionaries: ITaxesDictionary[] = yield Effects.call(service)
    yield Effects.put({
      dict: dictionaries,
      type: PaymentDictionaryActions.TaxDictionaryAccepted,
    })
  } catch (e) {
    console.error(e)
  }
}

function* saveTaxes(action) {
  try {
    const actionNames = fetchActionsName(ActionNames.UpdateTaxes)
    const [{ service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(actionNames.input, actionNames.output, updateTaxes),
      ),
    ])

    const dictionaries: ITaxesDictionary[] = yield Effects.call(
      service,
      action.dict,
    )
    yield Effects.put({
      dict: dictionaries,
      type: PaymentDictionaryActions.TaxDictionaryAccepted,
    })
    yield put(fireToastSuccess(i18n.t('user_settings_updated')))
  } catch (e) {
    console.error(e)
  }
}

function* addTax(action) {
  try {
    const actionNames = fetchActionsName(ActionNames.UpdateTaxes)
    const [{ service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(actionNames.input, actionNames.output, updateTaxes),
      ),
    ])

    const dictionaries: ITaxesDictionary[] = yield Effects.call(service, [
      action.tax,
    ])

    const d = dictionaries
      .filter(d => !d.deleted)
      .find(
        d =>
          Number(d.rate) === Number(action.tax.rate) ||
          d.rate === action.tax.rate,
      )

    yield Effects.put({
      dict: dictionaries,
      type: PaymentDictionaryActions.TaxDictionaryAccepted,
    })

    if (action.second) {
      yield Effects.put(
        change('services', `services[${action.index}].second_tax`, d.id),
      )
    } else {
      yield Effects.put(
        change('services', `services[${action.index}].first_tax`, d.id),
      )
    }
  } catch (e) {
    console.error(e)
  }
}

export default function*() {
  yield Effects.takeEvery(PaymentDictionaryActions.RequestTaxes, loadTaxes)
  yield Effects.takeEvery(PaymentDictionaryActions.SaveTaxes, saveTaxes)
  yield Effects.takeEvery(PaymentDictionaryActions.AddTax, addTax)
}
